import { useInfiniteQuery } from '@tanstack/react-query'
import { httpGetReviewers } from '@/features/luxe-submissions/http/luxe-submissions.http'
import type { LuxeReviewerSection } from '@/features/luxe-submissions/types'

export const REVIEWERS_QUERY_KEY = 'reviewers'

export const useGetReviewers = (
	section: LuxeReviewerSection,
	search?: string
) => {
	const query = useInfiniteQuery({
		queryKey: [REVIEWERS_QUERY_KEY, section, search],
		queryFn: ({ pageParam }) =>
			httpGetReviewers({ section, search, page: pageParam }),
		initialPageParam: 1,
		getNextPageParam: ({ meta }) =>
			meta.currentPage < meta.lastPage ? meta.currentPage + 1 : null
	})

	return {
		...query,
		// Flatten pages into a single array of reviewers
		remappedData: query.data?.pages.flatMap((page) => page.data) || []
	}
}
